export default
{
  NoticeVisitAndRents: [],
  NoticeVisitAndRent: {},
}
